import { render, staticRenderFns } from "./m-sku.vue?vue&type=template&id=d4c287a6&scoped=true&"
import script from "./m-sku.vue?vue&type=script&lang=js&"
export * from "./m-sku.vue?vue&type=script&lang=js&"
import style0 from "./m-sku.vue?vue&type=style&index=0&id=d4c287a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c287a6",
  null
  
)

export default component.exports